/* @ngInject */
export class TabContainerController {
  /* @ngInject */
  constructor ($scope, $timeout) {
    this.$scope = $scope
    this.$timeout = $timeout
    this.tabs = []
  }

  $onInit () {

    console.log('TabContainerController : init')

    this.onCurrentTabChange = this.onCurrentTabChange.bind(this)
    this.unsubscribeListener = this.$scope.$on('CURRENT_TAB_CHANGE', this.onCurrentTabChange)
  }

  $onDestroy() {
    this.unsubscribeListener()
  }

  addTab(tab) {
    if (this.tabs.length === 0) {
      tab.active = true
    }
    this.tabs.push(tab)
    this.tabs.sort(this.sortTabs)
  }

  removeTab(tab) {
    // je supprime l'onglet
    this.tabs = this.tabs.filter(t => t !== tab)
  }

  sortTabs(a,b) {
    if (b.staysLast) {
      return -1;
    }
    if (a.staysLast) {
      return 1;
    }
    return 0;
  }

  selectTab(tab) {

    this.tabs.forEach(tab => {
      tab.active = false
    })
    tab.active = true
  }

  onCurrentTabChange(event, data) {
    var newIndex = data.newIndex
    if(newIndex === undefined) return

    // Dès que TabContainer reçoit un nouvel index,
    // il récupere l'onglet à cet index et le rend actif
    // $timeout est un setTimeout wrappé par Angular (il déclenche un cycle de refresh à la fin du timeout)

    // C'est une petite astuce utile car sinon la selection de l'onglet intervient trop tôt
    // donc ici on attend 100ms, le temps que l'onglet du nouvel échelon soit bien créé dans l'interface puis on le selectionne.

    this.$timeout(() => {
      var currentTab = this.tabs[newIndex]
      if(currentTab) {
        this.selectTab(currentTab)
      }
    }, 100)

  }
}



// WEBPACK FOOTER //
// ./src/client/common/uiComponents/TabContainer/tab-container.controller.js